import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import classSet from 'classnames';
import { t } from 'c-3po';
import {
    getRoom,
    MESSAGE_STATUS_SENDING,
    MESSAGE_STATUS_DELIVERED,
    MESSAGE_STATUS_NOT_DELIVERED,
    MESSAGE_STATUS_READ,
    MAX_FILE_SIZE_LIMIT,
} from '@evo/chat-core';

import * as a from '../../../../../../../libs/actions';
import * as aggr from '../../../../../../../libs/aggregation';
import { getSocketStore, getMessageStatus, getFileUrl } from '../../../../../../../libs/utils';
import { getUserName, humanizeChatDate } from '../../../../../../../libs/helpers';
import { momentInCurrentTimeZone } from '../../../../../../../libs/date';

import { toJS } from '../../../../../../helpers/ImmutableToJS';

import { Processing } from '../processing';

import { LightboxGallery } from '../../../../../../components/lightboxGallery';
import { Spinner } from '../../../../../../ui/spinner';
import { Icon } from '../../../../../../ui/icon';
import { ImagePlaceholder } from '../../../../../../ui/imagePlaceholder';

// styles
import css from './fileMessage.sss';

// images
import CheckIconSvg from './images/check.icon.svg';
import WarningIconSvg from './images/warning.icon.svg';


class FileMsgView extends React.Component {

    static propTypes = {
        users: PropTypes.object,
        extra: PropTypes.object,
        firstUnreadMsgId: PropTypes.any,
        msgId: PropTypes.any,
        msg: PropTypes.object,
        isLastMsg: PropTypes.bool,
        messageStatus: PropTypes.string,
        intersectionObserver: PropTypes.object,
        isOpenToolTip: PropTypes.bool,
        lastReadMessageId: PropTypes.number,
        dialogOwner: PropTypes.any,
        newMsgMarkShown: PropTypes.any,
        markMsgRead: PropTypes.func,
        retrySendMsg: PropTypes.func,
        retrySendFile: PropTypes.func,
        retrySendFileCtx: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            originalImgUrl: getFileUrl(props.msg),
            previewImgUrl: getFileUrl(props.msg, 150, 150)
        }
    }

    componentDidMount() {
        const { intersectionObserver } = this.props;

        this.newMessageMark && intersectionObserver.observe(this.newMessageMark);
    }

    componentDidUpdate() {
        const { isOpenToolTip, isLastUnsentMsg } = this.props;

        if (isOpenToolTip && isLastUnsentMsg) this.props.triggerScroll();
    }

    componentWillUnmount() {
        URL.revokeObjectURL(this.state.originalImgUrl);
    }

    toggleImagePopup = () => {
        this.props.send(a.EVENT_DIALOG_TOGGLE_IMAGE_POPUP, { msgId: this.props.msg.id });
    }

    renderFilterErrors = () => {
        return t`o(╥﹏╥)o Что-то пошло не так`;
    }

    render() {
        const {
            msg,
            messageStatus,
            dialogOwner,
            retrySendFile,
            retrySendFileCtx,
            isInCompanyRole,
            companyManagers,
            users,
            isOpenToolTip,
            imagePopupOpen,
            imagePopupMsgId,
            isErrorOnFilesSave,
            firstUnreadMsgId,
            newMsgMarkShown,
            isLastUnsentMsg,
        } = this.props;
        const showHint = isLastUnsentMsg && isOpenToolTip;
        const maxFileSize = Math.round(MAX_FILE_SIZE_LIMIT / 1000000);

        const itemRight =
            dialogOwner === msg.user_ident ||
            (isInCompanyRole && companyManagers.includes(msg.user_ident));

        return (
            <li
                className={itemRight ? css.rootTypeRight : css.root}
                key={`${msg.id}chatMsg`}
                {...{[isLastUnsentMsg ? `data-msg${msg.id}`.slice(0, 12) : 'data-none']: 'true'}}
                ref={(node) => {
                    if (isLastUnsentMsg) this.msgNode = node;
                    else this.msgNode = null;
                }}
            >
                {msg.id === Number(firstUnreadMsgId) && (
                    dialogOwner !== msg.user_ident) && (
                    <div
                        ref={(node) => { this.newMessageMark = node; }}
                        className={css.statusWrapper}
                    >
                        <span
                            className={classSet({
                                [css.status]: true,
                                [css.statusThemeOrange]: newMsgMarkShown,
                                [css.statusThemeRed]: !newMsgMarkShown,
                            })}
                        >
                            {t`Новое сообщение`}
                        </span>
                    </div>
                )}
                <div className={css.messageHolder}>
                    <div className={css.message}>
                        <div className={css.name} data-qaid='name_field'>
                            {getUserName(users[msg.user_ident], this.props.extra)}{`: `}
                        </div>
                        {messageStatus === MESSAGE_STATUS_SENDING ? (
                            <div className={css.loader}>
                                <Spinner size='30' />
                            </div>
                        ) : (
                            <React.Fragment>
                                {(!msg.oversized && this.state.previewImgUrl) ? (
                                    <span
                                        onClick={this.toggleImagePopup}
                                        className={css.imageHolder}
                                    >
                                        <img
                                            className={css.image}
                                            src={this.state.previewImgUrl}
                                        />
                                    </span>
                                ) : (
                                    <span className={css.imageHolder}>
                                        <ImagePlaceholder />
                                    </span>
                                )}
                            </React.Fragment>
                        )}
                        <span className={css.messageStatus}>
                            <span
                                className={css.date}
                                title={momentInCurrentTimeZone(msg.date_sent).format('HH:mm DD.MM.YYYY')}
                            >
                                {humanizeChatDate(msg.date_sent)}
                            </span>
                            <span className={css.statusIconHolder}>
                                {messageStatus === MESSAGE_STATUS_DELIVERED &&
                                    <span title={t`Доставлено`}>
                                        <Icon
                                            className={css.statusIcon}
                                            glyph={CheckIconSvg}
                                        />
                                    </span>
                                }
                                {messageStatus === MESSAGE_STATUS_READ &&
                                    <span title={t`Прочитано`}>
                                        <Icon
                                            className={css.statusIcon}
                                            glyph={CheckIconSvg}
                                        />
                                        <Icon
                                            className={css.statusIcon}
                                            glyph={CheckIconSvg}
                                        />
                                    </span>
                                }
                                {messageStatus === MESSAGE_STATUS_NOT_DELIVERED && (
                                    <span title={t`Ошибка`}>
                                        <Icon
                                            className={css.messageTickIconRed}
                                            glyph={WarningIconSvg}
                                        />
                                    </span>
                                )}
                            </span>
                        </span>
                    </div>
                </div>
                {msg.oversized && (
                    <span className={css.textError}>
                        {t`Файл превышает максимальный размер в ${maxFileSize} MB`}
                    </span>
                )}
                <Processing
                    status={messageStatus}
                    retry={isErrorOnFilesSave ? retrySendFile : retrySendFileCtx}
                    msgId={msg.id}
                    isFilesSizeError={msg.oversized}
                    isFilesSaveError={isErrorOnFilesSave}
                />
                <LightboxGallery
                    visible={(msg.id === imagePopupMsgId) && imagePopupOpen}
                    showControls={false}
                    // TODO you can use array of images
                    images={[this.state.originalImgUrl]}
                    onClose={this.toggleImagePopup}
                />
                {showHint && (
                    <div
                        className={css.errorHint}
                        data-qaid='hint_popup'
                    >
                        {this.renderFilterErrors()}
                    </div>
                )}
            </li>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));
    const currentChatHistory = currentChatRoom.get('history');
    const dialogOwner = aggr.getDialogOwner(state);

    const lastReadMessageId = currentChatRoom.get('last_read_counter');
    const firstUnreadMsg = currentChatHistory.find(
        (msg) => msg.get('id') > lastReadMessageId && !msg.get('context_item_id'));
    const firstUnreadMsgId = firstUnreadMsg ? firstUnreadMsg.get('id') : '0';
    const lastUnsentMsg = currentChatHistory.findLast((msg) => msg.get('isTemporaryMessage'));

    const msg = currentChatRoom.get('history').find((m) => m.get('id') === ownProps.msgId);
    const messageStatus = getMessageStatus(state, msg);

    return {
        users: currentChatRoom.get('users'),
        extra: currentChatRoom.get('extra'),
        msg,
        dialogOwner,
        currentChatRoom,
        messageStatus,
        firstUnreadMsgId,
        errors: state.get('errors'),
        isOpenToolTip: state.getIn(['isOpen', 'dialogToolTip']),
        isLastUnsentMsg: lastUnsentMsg && lastUnsentMsg.get('id') === msg.get('id'),
        newMsgMarkShown: state.get('newMsgMarkShown'),
        imagePopupOpen: state.get('imagePopup').get('open'),
        imagePopupMsgId: state.get('imagePopup').get('msgId'),
        isErrorOnFilesSave: currentChatRoom.get('isErrorOnFilesSave')
    };
};

export const FileMsg = connect(mapStateToProps)(toJS(FileMsgView));
